import React from 'react';
import style from '../../../grid-page.module.less';
import PagingControlWrapper from '../../PagingControlWrapper';
import { useExternalInventoryContext } from './external-inventory-context';

export const ExternalInventoryPagingWrapper = () => {
  const { totalRecords } = useExternalInventoryContext();
  return (
    <div className={style['paging-footer']}>
      <PagingControlWrapper totalRecords={totalRecords} />
    </div>
  );
};
